<template>
    <div id="presets">
        <div id="app-layout-right-column__content__title">
            <span>Presets</span>
            <SavePresetButton v-if="!isCurrentPlanFree" class="ml-2" />
        </div>

        <PlanUpgradeNotificationInSidebar v-if="isCurrentPlanFree" />
        <div v-else class="scrollable-con">
            <div v-if="!filteredPresetFolders.length">
                <span class="d-block mt-2">Presets allow you to save your creative edits for easy access across all your projects.</span>
                <span class="d-block mt-5">Get started by saving a look or importing an existing Preset using the icon above.</span>
            </div>
            <v-expansion-panels v-else accordion dark v-model="panel" multiple>
                <v-expansion-panel
                    v-for="presetFolder in filteredPresetFolders"
                    :key="presetFolder.id"
                >
                    <v-expansion-panel-header>
                        <span>{{ presetFolder.name }}</span>
                        <v-menu left nudge-left="20px" :content-class="'file-options-container--no-icons'">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="folder-options-button mr-1">
                                    <v-icon size="18" class="material-icons" v-bind="attrs" v-on="on">more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item @click="openDeleteFolderModal(presetFolder)">
                                    <span class="v-list-item__title">Delete Folder</span>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <PresetItem v-for="preset in presetFolder.files" :key="preset.id" :preset="preset" />
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SavePresetButton from "@/components/app/buttons/SavePresetButton.vue";
import PresetItem from "@/components/app/presets/PresetItem.vue";
import PlanUpgradeNotificationInSidebar from "@/components/app/ui/PlanUpgradeNotificationInSidebar.vue";

export default {
    components: {PresetItem, SavePresetButton, PlanUpgradeNotificationInSidebar},
    data() {
        return {
            panel: []
        }
    },
    computed: {
        ...mapGetters('User', ['isCurrentPlanFree']),
        ...mapState('App', ['IDT']),
        ...mapState('UserFiles', ['presets']),
        ...mapGetters('UserFiles', ['filteredPresetFolders'])
    },

    methods: {
        openDeleteFolderModal(folder) {
            this.$store.dispatch("UserFiles/selectPresetFolder", folder.id);
            window.UI.showModal(window.UI.modals.presets.deleteFolder.el);
        },
    },
}
</script>

<style lang="scss" scoped>
#presets {
    display: grid;
    align-content: start;

    > span {
        width: 100%;
        display: block;
        font-size: 1.25rem;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 10px;

        &:first-of-type {
            margin-top: 10px;
        }

        &:not(:first-of-type) {
            margin-top: 30px;
            margin-bottom: 20px;
            border-top: 1px solid var(--primary);
            padding-top: 20px;
        }
    }

    #save-preset-button {
        position: absolute;
        top: 50%;
        right: -6px;
        transform: translateY(-50%);
    }

    #app-layout-right-column__content__title ::v-deep .v-btn,
    .v-expansion-panels ::v-deep .v-btn{
        min-width: auto;
        height: auto;
        box-shadow: none;
        background-color: transparent;
        color: var(--font-default-color);
        padding: 3px;

        &--active {
            &::before {
                background-color: var(--color-accent);
                opacity: 0.4;
            }
        }

        &--disabled,
        &--disabled .v-icon {
            background-color: transparent !important;
            color: var(--font-default-color) !important;
            opacity: 0.4;
        }

        i {
            font-size: 1.7rem;
        }
    }

    ::v-deep .v-expansion-panel {
        background-color: transparent;

        &:after {
            border-color: var(--color-group-separator);
        }

        &-header {
            padding: 0;
            min-height: 30px;

            span {
                font-size: 1.1rem;
            }

            .folder-options-button {
                flex: initial;
            }

            .v-icon {
                font-size: 18px;
            }
        }

        &-content__wrap {
            padding: 0 0 3px;
        }
    }
}
</style>